import { observer } from 'mobx-react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import {
  PDFPreview,
  StepObj,
  StepperComponent,
} from '@roc/client-portal-shared/components';
import { Grid, Typography } from '@material-ui/core';
import { ReferralWiringInformationForm } from './referralWiringInformationForm';
import { ReferralWiringInformationSignature } from './referralWiringInformationSignature';
import React from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { ReferralWiringInformationSignatureSigned } from './referralWiringInformationSignatureSigned';

const useStyles = makeStyles(theme =>
  createStyles({
    stepper: {
      paddingLeft: 0,
      paddingRight: 0,
      [theme.breakpoints.down('xs')]: {
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
      },
    },
  })
);

export const ReferralWiringInformation = observer(() => {
  const { referralWiringInformationStore: store } = useStore();
  const classes = useStyles();

  const steps: StepObj[] = [
    {
      title: 'ACH Bank Information',
      icon: null,
      completed: store.activeStep > 0,
    },
    {
      title: 'Confirmation',
      icon: null,
      completed: store.isSigned,
    },
  ];

  return (
    <>
      <Typography>
        Please provide your Referral ACH Information so that you can receive
        payment for the referrals you’ve brought to us, once they close a loan.
      </Typography>
      <StepperComponent
        activeStep={store.activeStep}
        steps={steps}
        disableNavigation={true}
        className={classes.stepper}
      />
      <Grid container>
        {store.isSigned && !store.edit ? (
          <ReferralWiringInformationSignatureSigned store={store} />
        ) : (
          <>
            {store.activeStep === 0 && (
              <ReferralWiringInformationForm store={store} />
            )}
            {store.activeStep === 1 && (
              <ReferralWiringInformationSignature store={store} />
            )}
          </>
        )}
      </Grid>
      <PDFPreview
        open={store.isPdfPreviewModalOpen}
        title={store.pdfTitle}
        data={store.pdfData}
        headers={{}}
        fileName={store.pdfTitle}
        onClose={() => {
          store.pdfTitle = null;
          store.pdfData = null;
          store.isPdfPreviewModalOpen = false;
        }}
      />
    </>
  );
});
